import React from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import { LoadMoreCollectionStories } from "@quintype/components";
import get from "lodash/get";

import More from "../../../atoms/More";
import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";

import { setLoading } from "../../../helper/actions";
import { staticTexts } from "../../../utils/Translate";
import DfpAd from "../../../dfp-ad";

import "./organism1.m.css";

const Organism1 = ({ collection, setLoading, publisherAttributes, captionStyle = "" }) => {
  const numStoriesToLoad = 6;
  const storyList = collection.items.filter(item => item.type === "story").map(item => item.story);

  if (!(storyList && storyList.length)) {
    return null;
  }

  const MoreCollectionStories = (params, numStoriesToLoad) => {
    const { stories, onLoadMore, noMoreStories, loading } = params;
    const firstSetStories = stories.slice(0, 4); // Before Advertisement
    const remainingStories = stories.slice(4, stories.length); // After Advertisement

    setLoading(loading);

    const MoreComponent = (
      <div styleName={`load-more-view ${publisherAttributes.lang === "en" ? "en-load-more-view" : ""}`}>
        <More type="load-more" text={staticTexts(publisherAttributes.lang).more} onClick={onLoadMore} />
      </div>
    );

    return (
      <div>
        {firstSetStories.map((story, index) => (
          <CustomStoryCard2
            key={index}
            story={story}
            isImageCaptionRequired={false}
            isSection={false}
            aspectRatio={[3, 2]}
            imageType="image3x2"
            headlineType={27}
            subHeadlineType={6}
            widths={[200]}
            updatedFont={true}
          />
        ))}

        <div styleName="ad-wrapper">
          <DfpAd adtype="News_336x280_R1" />
        </div>

        {remainingStories.map((story, index) => (
          <React.Fragment key={index}>
            {index % 6 === 0 && index >= 6 && (
              <div styleName="ad-wrapper">
                <DfpAd adtype="News_336x280_R1" />
              </div>
            )}
            <CustomStoryCard2
              story={story}
              isImageCaptionRequired={false}
              isSection={false}
              aspectRatio={[3, 2]}
              imageType="image3x2"
              headlineType={27}
              subHeadlineType={6}
              widths={[200]}
              captionStyle={captionStyle}
              updatedFont={true}
            />
          </React.Fragment>
        ))}

        {numStoriesToLoad <= stories.length && !noMoreStories ? MoreComponent : null}
      </div>
    );
  };

  return (
    <LoadMoreCollectionStories
      template={e => MoreCollectionStories(e, numStoriesToLoad)}
      collectionSlug={collection.slug}
      data={Object.assign(
        {},
        { collection },
        { stories: [...storyList.map(story => story).slice(0, 10)] },
        { storiesPerPage: numStoriesToLoad }
      )}
      numStoriesToLoad={numStoriesToLoad}
      params={{ "item-type": "story" }}
    />
  );
};

const mapDispatchToProps = dispatch => ({
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

Organism1.propTypes = {
  collection: object.isRequired,
  setLoading: func,
  publisherAttributes: object,
  captionStyle: string
};

export default connect(mapStateToProps, mapDispatchToProps)(Organism1);
